/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { DELETE_USER } from '../../api/graphql';
import { vappContainer } from '@/application';
import { notificationConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface deleteUserProps {
  email: string;
}

export interface IDeleteUserMethods extends IPluginMethodMap {
  getDeleteUser(args: deleteUserProps): Promise<any>;
}

export class DeleteUserService implements IAgentPlugin {
  readonly methods: IDeleteUserMethods;

  constructor() {
    this.methods = {
      getDeleteUser: this.getDeleteUser.bind(this),
    };
  }

  async getDeleteUser(args: deleteUserProps) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client.mutation(
          DELETE_USER,

          {
            vuid: args,
          }
        );

        // .mutate({
        //   mutation: DELETE_USER,
        //   variables: {
        //     vuid: args,
        //   },
        //   fetchPolicy: 'no-cache',
        // });
        if (res?.data) {
          return {
            ...res?.data?.removeUser,
            notification: notificationConfig?.deleteUserSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
